<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">Add Stock Keeping Unit</h4>
                        <h6 class="card-subtitle">Please keep your profile information always current in order to help you when you contact us.</h6>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="code">
                                    SKU Code
                                </label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('code')}"
                                           class="form-control"
                                           data-vv-as="Code"
                                           id="code"
                                           name="code"
                                           placeholder="SKU Code"
                                           type="text"
                                           v-model="product.code"
                                           v-validate="'required'">
                                    <!--                                    <small class="text-muted">5 digit numbers only</small>-->
                                    <div class="invalid-feedback" v-if="submitted && errors.has('code')">
                                        {{ errors.first('code') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="good">
                                    Product
                                </label>
                                <div class="col-sm-6 mt-2" v-if="!product.good">
                                    <a class="" data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                                       href="javascript:void(0)"><b>Click here to
                                        add commodity</b></a>
                                </div>
                                <div class="col-sm-6" v-else>
                                    <p class="form-control" data-target="#searchAndSelectCommodityModal" data-toggle="modal">{{product.good.name}}
                                        <span>({{product.good.code}})</span> -{{product.good.variety}}</p>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="quantity">
                                    Quantity
                                </label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('quantity')}"
                                           class="form-control"
                                           data-vv-as="Quantity"
                                           id="quantity"
                                           name="quantity"
                                           placeholder="Quantity"
                                           type="number"
                                           step="any"
                                           v-model="product.quantity"
                                           v-validate="'required','min_value:0','decimal:0'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('quantity')">
                                        {{ errors.first('quantity') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="unit">
                                    Unit
                                </label>
                                <div class="col-sm-6">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('unit')}"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="true"
                                                 :internal-search="false"
                                                 :options="units"
                                                 :searchable="true"
                                                 :selectLabel="''"
                                                 :show-no-results="false"
                                                 class="form-control multiselect-sm"
                                                 data-vv-as="Unit"
                                                 id="unit"
                                                 label="unit"
                                                 name="unit"
                                                 placeholder="Unit"
                                                 track-by="id"
                                                 @search-change="searchUnits"
                                                 v-model="product.unit"
                                                 v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.symbol}} - {{props.option.name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.symbol }}</h5>
                                                <div>{{ props.option.name }}</div>
                                            </div>
                                        </template>
                                        <span slot="noResult">Unit not found</span>
                                    </multiselect>

                                    <div class="invalid-feedback" v-if="submitted && errors.has('unit')">
                                        {{ errors.first('unit') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button class="btn waves-effect waves-light btn-secondary" @click="reset" type="button">Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <search-select-commodity :checked-commodity-ids="commodityIds" :single-select="true"
                                 @commodity-select="setCommodity"></search-select-commodity>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapGetters} from "vuex";
import SearchSelectCommodity from "../../common/SearchSelectCommodity";
export default {
    name: "MarketplaceNewSKU",
    components: {SearchSelectCommodity, Multiselect},
    computed: {
        ...mapGetters(["currentUser", "currentOrg"])
    },
    data() {
        return {
            isLoading: false,
            submitted: false,
            product: {
                code: null,
                good: null,
                quantity: null,
                unit: null
            },
            goods: [],
            units: [],
            commodityIds: []
        }
    },
    mounted() {
    },
    methods: {
        async save() {
            try {
                console.log(this.product.unit)
                let payload = {
                    code: this.product.code,
                    commodity_id: this.product.good.id,
                    quantity: this.product.quantity,
                    unit_id: this.product.unit.id
                }
                await this.$http.put(`/marketplaces/${this.currentOrg.marketplace_id}/products`, payload);
                this.$toastr('success', 'Stock Keeping Unit Added', 'Success');
                await this.$router.push({name: "marketplaceproducts"});
            } catch(e) {
                console.error(e);
                if(e.response.data.code === "23505"){
                    this.$toastr('error', 'A product with same SKU exists', 'Failure');
                } else{
                    this.$toastr('error', 'Stock Keeping Unit Add Failed', 'Failure');
                }
            }
        },
        async searchGoods(search) {
            this.isLoading = true;
            let reply      = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/commodities/search", {
                params: {
                    search,
                    excludeOld: true
                }
            });
            this.goods     = reply.data;
        },
        async searchUnits(search) {
            this.isLoading = true;
            let reply      = await this.$http.get("/unit/search", {
                params: {
                    search
                }
            });
            this.units     = reply.data;
        },
        handleSubmit(e) {
            this.submitted = true;
            this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.save();
                    }
                });
        },
        reset() {
            this.product = {
                code: null,
                good: null,
                quantity: null,
                unit: null
            };
        },
        setUnit(){
            this.product.unit = this.product.good.unit;
        },
        setCommodity(e) {
            let commodity = e.length > 0 ? e[0] : null;
            if (commodity) {
                this.product.good = commodity;
                this.product.unit = commodity.unit;
                this.commodityIds = [commodity.id];
            }

        }
    }
}
</script>

<style scoped>

</style>
